import { useEffect } from "react";
import { useLocation, useNavigation } from "react-router-dom";
import { useAuth } from "@/features/auth";
import { resolveTelemetryPage, visitTelemetryPage } from "@/features/telemetry";

/** Central route observer strips private paths and ignores anonymous, unauthorized and unresolved destinations. */
export function TelemetryObserver() {
  const { pathname, search } = useLocation();
  const navigation = useNavigation();
  const { roles, requestScope } = useAuth();
  useEffect(() => {
    if (navigation.state !== "idle") return;
    const page = requestScope?.tenantId
      ? resolveTelemetryPage(pathname, search, roles)
      : null;
    visitTelemetryPage(page);
  }, [pathname, search, roles, requestScope, navigation.state]);
  return null;
}
